module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-card', {
    attrs: {
      "image": _vm.userImage,
      "imageLink": ("/" + (_vm.user.username)),
      "title": _vm.userName,
      "titleLink": ("/" + (_vm.user.username)),
      "description": _vm.userType,
      "meta": _vm.userMeta
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7585b316","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_card.vue
// module id = 1782
// module chunks = 180